module.exports = __webpack_public_path__ + "img/optimal.1e134bf9.png";